import React, {type JSX} from 'react';
import {Radio, type RadioProps} from '@mui/material';
import {styled, keyframes} from '@mui/material/styles';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const StyledIcon = styled('span')(({theme}) => ({
  display: 'inline-block',
  borderRadius: '50%',
  width: 16,
  height: 16,
  boxSizing: 'border-box',
  border: `1px solid ${theme.palette.grey['400']}`,
  'input:disabled ~ &': {
    opacity: 0.5,
  },
}));

const StyledCheckedIcon = styled('span')(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '50%',
  width: 16,
  height: 16,
  boxSizing: 'border-box',
  border: `1px solid ${theme.palette.grey['400']}`,
  '&:before': {
    display: 'block',
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.main,
    animation: `${fadeIn} ${theme.transitions.duration.standard}ms ${theme.transitions.easing.sharp}`,
    content: '""',
  },
  'input:disabled ~ &:before': {
    opacity: 0.5,
  },
}));

type Props = {
  slotProps?: {
    input?: React.InputHTMLAttributes<HTMLInputElement> & {
      'data-testid'?: string;
    };
  };
} & RadioProps;

export function InputRadioButton(props: Readonly<Props>): JSX.Element {
  return (
    <Radio
      disableRipple
      color="default"
      checkedIcon={<StyledCheckedIcon />}
      icon={<StyledIcon />}
      {...props}
    />
  );
}
